export default __webpack_public_path__ + "static/media/jp-morgan.61fceeaa.svg";